import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $swiperContainer: this.el.querySelector('.swiper'),
      $swiperSlides: this.el.querySelectorAll('.swiper-slide'),
      $swiperPagination: this.el.querySelector('.swiper-pagination'),
      $swiperNextButton: this.el.querySelector('.swiper-button-next'),
      $swiperPrevButton: this.el.querySelector('.swiper-button-prev')
    };

    this.initSwiper();
  }

  initSwiper() {
    const { length } = this.dom.$swiperSlides;
    const that = this;

    this.swiper = new Swiper(this.dom.$swiperContainer, {
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      rewind: false,
      direction: 'horizontal',
      spaceBetween: 30,
      watchOverflow: true,
      enabled: length > 1,
      roundLengths: false,
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        672: {
          slidesPerView: 2
        },
        1056: {
          slidesPerView: 3
        }
      },
      // Custom pagination per specs, total length should be shown
      on: {
        init(sw) {
          that.dom.$swiperPagination.innerHTML = `${
            sw.activeIndex + 1
          } / ${length}`;
        },
        slideChange(sw) {
          that.dom.$swiperPagination.innerHTML = `${
            sw.activeIndex + 1
          } / ${length}`;
        }
      },

      navigation: {
        nextEl: this.dom.$swiperNextButton,
        prevEl: this.dom.$swiperPrevButton
      },
      watchSlidesProgress: true
    });
  }
}

export default Module;
